import { render, staticRenderFns } from "./DashboardKi.vue?vue&type=template&id=6bf318b9&scoped=true&"
import script from "./DashboardKi.vue?vue&type=script&lang=ts&"
export * from "./DashboardKi.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardKi.vue?vue&type=style&index=0&id=6bf318b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf318b9",
  null
  
)

export default component.exports